<template>
    <sa-page-layout :btnRefreshVisible="true" :btnNewVisible="false" :pathResource="pathResource" @refresh="onRefresh" :linkedit="linkedit">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovo">
                <b-icon icon="plus"> </b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-body">
            <lingue-list-component ref="cmpLingueList"></lingue-list-component>
            <lingua-modal-edit-component ref="cmpLinguaModalEdit" @afterSave="onAfterSave"></lingua-modal-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
// import axios from "axios";
// import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import LinguaModalEditComponent from "./LinguaModalEditComponent.vue";
import LingueListComponent from "./LingueListComponent.vue";
export default {
    components: { SaPageLayout, LingueListComponent, LinguaModalEditComponent },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            pathResource: "/lingue",
            linkedit: "/struttura",
            filtro: {},
            filterOn: [],
        };
    },
    mounted: function () {
        let me = this;
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadData() {
            let me = this;
            me.$refs.cmpLingueList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onClickNuovo() {
            let me = this;
            me.$refs.cmpLinguaModalEdit.show();
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
